import React, { useCallback, useEffect, useState } from 'react';
import VerificationInputModule from 'react-verification-input';
import { Button, Flex, Pane, Text } from '@leverege/ui-elements';
import { GlobalState, UI } from '@leverege/ui-redux';
import { connect } from 'react-redux';
import { Auth } from '@leverege/api-redux';
import I18N from '@leverege/i18n';
import { push } from 'connected-react-router';
import Login from "./Login.js";
import LogoComponent from "./views/LogoComponent.js";
import S from './Login.css';
const VerificationInput = VerificationInputModule.default;
const VALID_CHARS = 'CcDdEeHhKkMmPpRrTtUuWwXxYy012458-';
const {
  t
} = I18N.ns('login.DeviceLogin');
function DeviceLogin(props) {
  const {
    deviceCodeError,
    isLoggedIn,
    onConfirmUserCode,
    onLogin,
    profile,
    userCode
  } = props;
  const [sUserCode, setSUserCode] = useState();
  useEffect(() => {
    const q = new URLSearchParams(window.location.search);
    const userCode = q.get('user_code');
    if (userCode) {
      GlobalState.dispatch(UI.set('login.userCode', {
        value: userCode,
        method: 'qr'
      }));
    }
  }, []);
  const onComplete = useCallback(value => {
    const val = value.toUpperCase();
    onConfirmUserCode(val).then(() => {
      GlobalState.dispatch(UI.set('login.userCode', {
        value: val,
        method: 'entry'
      }));
      GlobalState.dispatch(Auth.setUserCode(val));
    }).catch(err => {
      GlobalState.dispatch(UI.set('login.DeviceCodeError', err.message));
    });
  }, [onConfirmUserCode]);
  const onLogout = useCallback(() => {
    GlobalState.dispatch(Auth.logout()).then(() => {
      GlobalState.dispatch(Auth.setUserCode(userCode?.value));
    });
  }, [userCode]);
  const onConfirmUser = useCallback(evt => {
    onLogin?.();
  }, [onLogin]);
  const onCancelUserCode = useCallback(() => {
    GlobalState.dispatch(UI.set('login.userCode', null));
    GlobalState.dispatch(push(window.location.pathname));
  }, []);
  const onClearUserCodeError = useCallback(() => {
    GlobalState.dispatch(UI.set('login.userCode', null));
    GlobalState.dispatch(UI.set('login.DeviceCodeError', null));
    setSUserCode(null);
  }, []);
  if (deviceCodeError) {
    return /*#__PURE__*/React.createElement(DeviceCodeError, {
      userCode: sUserCode || userCode?.value,
      onClearUserCodeError: onClearUserCodeError
    });
  }
  if (userCode?.value && userCode?.method === 'qr') {
    return /*#__PURE__*/React.createElement(ConfirmUserCode, {
      userCode: userCode?.value,
      onSetUserCode: onComplete,
      onCancelUserCode: onCancelUserCode
    });
  }
  if (userCode?.value && isLoggedIn) {
    return /*#__PURE__*/React.createElement(ConfirmLoggedInUser, {
      profile: profile,
      onConfirm: onConfirmUser,
      onLogout: onLogout
    });
  }
  if (userCode?.value) {
    return /*#__PURE__*/React.createElement(Login, props);
  }
  return /*#__PURE__*/React.createElement(EnterUserCode, {
    onComplete: onComplete,
    userCode: sUserCode,
    setUserCode: setSUserCode
  });
}
function DeviceCodeError({
  onClearUserCodeError,
  userCode
}) {
  return /*#__PURE__*/React.createElement(Pane, {
    variant: "loginPane",
    layout: "flex:colMCenter"
  }, /*#__PURE__*/React.createElement(Pane, {
    variant: "loginPaneHalf",
    layout: "flex:colLCenterMiddle"
  }, /*#__PURE__*/React.createElement(LogoComponent, {
    variant: "loginLogo"
  }), /*#__PURE__*/React.createElement(Text, {
    variant: "bodySmallBoldCenter"
  }, t('codeErrorInstructions1')), /*#__PURE__*/React.createElement(Text, {
    variant: "userCode|title"
  }, userCode), /*#__PURE__*/React.createElement(Text, {
    variant: "bodySmallCenter"
  }, t('codeErrorInstructions2')), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    style: {
      alignSelf: 'stretch'
    },
    onClick: onClearUserCodeError
  }, t('cancel'))));
}
function ConfirmUserCode({
  userCode,
  onSetUserCode,
  onCancelUserCode
}) {
  return /*#__PURE__*/React.createElement(Pane, {
    variant: "loginPane",
    layout: "flex:colMCenter"
  }, /*#__PURE__*/React.createElement(Pane, {
    variant: "loginPaneHalf",
    layout: "flex:colLCenterMiddle"
  }, /*#__PURE__*/React.createElement(LogoComponent, {
    variant: "loginLogo"
  }), /*#__PURE__*/React.createElement(Text, {
    variant: "formBodyCenter"
  }, t('confirmCodeInstructions1')), /*#__PURE__*/React.createElement(Text, {
    variant: "userCode|title"
  }, userCode), /*#__PURE__*/React.createElement(Text, {
    variant: "caption"
  }, t('confirmCodeInstructions2')), /*#__PURE__*/React.createElement(Flex, {
    variant: "colM",
    className: S.buttons
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    style: {
      alignSelf: 'stretch'
    },
    onClick: () => onSetUserCode(userCode)
  }, t('continue')), /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    style: {
      alignSelf: 'stretch'
    },
    onClick: onCancelUserCode
  }, t('cancel')))));
}
function ConfirmLoggedInUser({
  profile,
  onConfirm,
  onLogout
}) {
  return /*#__PURE__*/React.createElement(Pane, {
    variant: "loginPane",
    layout: "flex:colMCenter"
  }, /*#__PURE__*/React.createElement(Pane, {
    variant: "loginPaneHalf",
    layout: "flex:colLCenterMiddle"
  }, /*#__PURE__*/React.createElement(LogoComponent, {
    variant: "loginLogo"
  }), /*#__PURE__*/React.createElement(Text, {
    variant: "formBodyCenter"
  }, t('confirmUserInstructions1')), /*#__PURE__*/React.createElement(Text, {
    variant: "userCode|title"
  }, profile?.name || profile?.username), /*#__PURE__*/React.createElement(Text, {
    variant: "caption"
  }, t('confirmUserInstructions2')), /*#__PURE__*/React.createElement(Flex, {
    variant: "colM",
    className: S.buttons
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    style: {
      alignSelf: 'stretch'
    },
    onClick: onConfirm
  }, t('continue')), /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    style: {
      alignSelf: 'stretch'
    },
    onClick: onLogout
  }, t('logout')))));
}
function EnterUserCode(props) {
  const {
    onComplete,
    userCode,
    setUserCode
  } = props;
  const onChange = useCallback(value => {
    const val = value.toUpperCase().replaceAll('-', '');
    setUserCode(val);
  }, []);
  return /*#__PURE__*/React.createElement(Pane, {
    variant: "loginPane"
  }, /*#__PURE__*/React.createElement(Pane, {
    variant: "loginPaneHalf",
    layout: "flex:colLCenterMiddle",
    style: {
      paddingBottom: 'var(--size-padSmall)'
    }
  }, /*#__PURE__*/React.createElement(LogoComponent, {
    variant: "loginLogo"
  }), /*#__PURE__*/React.createElement(Text, {
    variant: "formBodyCenter"
  }, t('instructions')), /*#__PURE__*/React.createElement(VerificationInput, {
    placeholder: "",
    validChars: VALID_CHARS,
    autoFocus: true,
    classNames: {
      character: S.character,
      characterSelected: S.characterSelected
    },
    length: 8,
    value: userCode,
    onChange: onChange,
    onComplete: onComplete
  })));
}
export default connect(state => {
  return {
    userCode: UI.get(state, 'login.userCode'),
    profile: Auth.getProfile(state.auth),
    isLoggedIn: Auth.isLoggedIn(state.auth),
    deviceCodeError: UI.get(state, 'login.DeviceCodeError')
  };
})(DeviceLogin);